import { call, put } from 'redux-saga/effects';
import { getFirmaOTP as getFirmaOTPAda } from '@bitComponents/adabyron/cqv2';
import { WEB_SERVICES } from './webServices';


export function* getSignatureOTP(params) {
  const {
    reduxUpdate,
    normalizeHttpErrors,
    phoneNumberOTP,
    cqId,
    context,
  } = params;
  try {
    const { successUpdate } = reduxUpdate;
    const getSignatureOTPParams = {
      phoneNumber: phoneNumberOTP,
      cqId,
    };

    const response = yield call(getFirmaOTPAda, getSignatureOTPParams, context);
    const { signatureURL } = { ...response };
    if (signatureURL) {
      yield put(successUpdate({ signatureURL, phoneNumberOTP }));
    }
    return signatureURL;
  } catch (error) {
    const { errorUpdate } = reduxUpdate;
    const errorNormalized = yield call(normalizeHttpErrors, WEB_SERVICES.GET_SIGNATURE_OTP, error);
    if (errorUpdate) {
      yield put(errorUpdate(errorNormalized));
    }
    throw error;
  }
}
